import styled, { css } from 'styled-components';

import Icon from 'components/icons';
import Switch from 'components/switch';

// Keeps toggle and label aligned.
export const Wrapper = styled.div<{ $nonClickable?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: ${({ theme }) => theme.default.colors.fonts.dark};
  ${({ $nonClickable }) =>
    $nonClickable &&
    css`
      cursor: not-allowed;
      * {
        cursor: not-allowed;
      }
    `}
`;

// UI copy next to the switch follows provided typography specs.
export const Label = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #1a2535;
  white-space: nowrap;
`;

// Compact badge that matches Figma sizing (22x22) and spacing.
export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
`;

export const BadgeIcon = styled(Icon)`
  width: 22px !important;
  height: 22px !important;
`;

// Switch + label row with required 5px gap.
export const Row = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

// Sized switch overrides the default antd size to 32x18.
export const ToggleSwitch = styled(Switch)<{ $nonClickable?: boolean }>`
  .ant-switch {
    /* Force the compact 32x18 footprint (antd default is 44x22). */
    width: 32px !important;
    min-width: 32px !important;
    height: 18px !important;
    line-height: 18px !important;
    padding: 0 !important;
  }
  /* Keep visual parity while loading/click-blocked. */
  .ant-switch-loading {
    opacity: 1 !important;
  }
  .ant-switch-handle {
    width: 16px;
    height: 16px;
    top: 1px;
    left: 1px;
  }
  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 17px);
  }
  ${({ $nonClickable }) =>
    $nonClickable &&
    css`
      .ant-switch {
        pointer-events: none;
      }
    `}
`;
